import styled from 'styled-components';
import {
  Text as TextLayoutComponent,
  Header as HeaderLayoutComponent,
} from '@playbookux/playbook-web-core';

export const Header = styled(HeaderLayoutComponent)`
  margin-bottom: 4px;
  color: #000;
`;

export const SavedFilterContainer = styled.div`
  border: 1px solid #ddd;
  border-radius: 5px;
  padding: 15px;
  margin-bottom: 15px;
  position: relative;
`;

export const SavedFilterLeftContainer = styled.div`
  display: flex;
  align-items: start;
`;

export const SavedFilterTopRow = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 5px;
`;

export const ThreeDotDropdown = styled.div`
  .ui.dropdown .menu {
    min-width: unset;
  }
  .ui.dropdown .menu > .item {
    color: ${({ theme }) => theme.color.textError};
  }
`;

export const FilterConditions = styled(TextLayoutComponent)`
  font-size: 14px;
  margin-left: 26px;
`;

export const FilterName = styled(TextLayoutComponent.Bold)`
  font-size: 14px;
  margin-bottom: 0;
  color: #000;
`;
